function InvitationsIcon(props)
{
    return (
        <svg className={props.class} width="1.2rem" height="1.2rem" viewBox="0 0 32 32" fill="rgb(162, 162, 162)"><path d="M29,4H3A3,3,0,0,0,0,7V25a3,3,0,0,0,3,3H29a3,3,0,0,0,3-3V7A3,3,0,0,0,29,4Zm-.72,2L16,14.77,3.72,6ZM30,25a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V7.23l13.42,9.58a1,1,0,0,0,1.16,0L30,7.23Z"/></svg>
    )
}

export default InvitationsIcon